import React from "react";
import PageSeo from "../../components/seo/PageSeo";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* THANKS (inscription) — design "Signal" */
export default function ThanksPage(props) {
  const { setShowModal, loader } = props;
  const { t } = useTranslation();

  if (!loader) return null;

  return (
    <div className="sg-page" style={{ maxWidth: 520, minHeight: "60vh", justifyContent: "center" }}>
      <PageSeo noindex title={t("signal.account-created")} />
      <div className="sg-panel" style={{ padding: 32, textAlign: "center" }}>
        <span className="brand-logo" style={{ fontSize: 26 }}>
          <span className="b-2fa">2FA</span><span className="b-sms">SMS</span>
        </span>
        <p className="sg-status sg-status--ok" style={{ justifyContent: "center", fontSize: 13, margin: "16px 0 8px" }}>
          {t("signal.account-created")}
        </p>
        <p className="sg-sub" style={{ fontSize: 14, marginBottom: 6 }}>{t("overview.thank-you")}</p>
        <p className="sg-sub" style={{ marginBottom: 6 }}>{t("overview.em-sent")}</p>
        <p className="sg-sub" style={{ marginBottom: 20 }}>{t("overview.verify-em")}</p>
        <NavLink
          onClick={() => setShowModal(true)}
          to="/"
          className="sg-btn sg-btn--primary"
        >
          {t("overview.log-inn")}
        </NavLink>
      </div>
    </div>
  );
}
